module.exports = __webpack_public_path__ + "img/icon_weekend.6a42a17e.png";